<template>
  <div class="covid-search-form-toptext vacci-toptext" v-if="isLessThanLargeDesktop">
    <h1>{{ title }}
      <template v-if="secondTitle">
        <span> {{ secondTitle }} </span>
      </template>
    </h1>
    <p>
      {{ text }}
    </p>
    <div v-if="displayRogerVoice" class="rogervoice-button-container white">
      <button
        class="roger-webapp-button"
        @click="$emit('onRogerVoiceClick')"
      >
        <svg
          role="img"
          aria-label="personnes sourdes et malentendantes"
          width="20px"
          height="20px"
          viewBox="0 0 28 28"
          version="1.1"
        >
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g
              transform="translate(-25.000000, -15.000000)"
              fill="#11485B"
              fill-rule="nonzero"
            >
              <!-- eslint-disable-next-line max-len -->
              <path d="M25.9906539,38.7287954 C26.1914126,38.7099473 26.3871587,38.6242568 26.5418066,38.4715019 L47.948796,17.0117337 C48.2263318,16.9667216 48.5207924,17.0512139 48.7347893,17.2652107 C49.0884036,17.618825 49.0884036,18.1921471 48.7347893,18.5457614 L43.2622095,24.0183412 C43.1353361,25.5608973 42.6764302,27.3276574 41.8599943,29.7618398 C41.7344207,30.1362342 41.6049456,30.5143346 41.4255642,31.0326031 C40.2196811,34.5166369 39.7763645,35.9625642 39.6757128,37.1686008 C39.9052608,37.3328538 40.0548606,37.6016995 40.0548606,37.9054861 C40.0548606,40.4059168 38.027861,42.4329164 35.5274303,42.4329164 C33.0269996,42.4329164 31,40.4059168 31,37.9054861 C31,37.4053999 31.4053999,37 31.9054861,37 C32.4055722,37 32.8109721,37.4053999 32.8109721,37.9054861 C32.8109721,39.4057445 34.0271719,40.6219442 35.5274303,40.6219442 C36.8377096,40.6219442 37.9313164,39.6942593 38.1872745,38.4598658 C37.97643,38.2940797 37.8410162,38.0366829 37.8410162,37.7476585 C37.8410162,36.0819695 38.2224275,34.7502995 39.7142012,30.4402714 C39.891849,29.9270119 40.0196526,29.5537925 40.1430252,29.1859605 C40.5179886,28.0680167 40.8115756,27.1044858 41.0274668,26.2530839 L33.9285436,33.352007 C34.0842016,33.626085 34.3787386,33.8109721 34.7164582,33.8109721 C35.2165443,33.8109721 35.6219442,33.4055722 35.6219442,32.9054861 C35.6219442,32.4053999 36.0273442,32 36.5274303,32 C37.0275165,32 37.4329164,32.4053999 37.4329164,32.9054861 C37.4329164,34.4057445 36.2167166,35.6219442 34.7164582,35.6219442 C33.8794119,35.6219442 33.1307906,35.243352 32.6324887,34.648062 L26.5457614,40.7347893 C26.1921471,41.0884036 25.618825,41.0884036 25.2652107,40.7347893 C24.9115964,40.381175 24.9115964,39.8078529 25.2652107,39.4542386 L25.9906539,38.7287954 Z M33.5703861,28.983482 L31.866142,30.666865 C31.8040311,29.2067804 31.6692266,28.0389206 31.4677527,26.9462033 C31.4566706,26.8860985 31.1125344,25.2166941 31.0559445,24.7692767 C31.018857,24.4760512 31,24.1960296 31,23.9085024 C31,21.6083506 32.7726205,20 35.0746873,20 C37.1702351,20 38.9113377,21.5219137 39.1269221,23.4949615 L37.8721266,24.7343975 C37.557445,24.5925283 37.3384024,24.2760954 37.3384024,23.9085024 C37.3384024,22.7613 36.335484,21.8109721 35.0746873,21.8109721 C33.735621,21.8109721 32.8109721,22.6499331 32.8109721,23.9085024 C32.8109721,24.1172669 32.8247438,24.3217722 32.8526027,24.5420334 C32.8988089,24.9073547 33.2257747,26.4934655 33.2487055,26.6178332 C33.3851774,27.3580039 33.4928929,28.1282694 33.5703861,28.983482 Z M42.7182788,19.9475654 L41.2748789,21.3732971 C40.5743965,18.588473 38.2100984,16.8109721 35.1493746,16.8109721 C31.6487716,16.8109721 28.8109721,19.6487716 28.8109721,23.1493746 C28.8109721,23.6494607 28.4055722,24.0548606 27.9054861,24.0548606 C27.4053999,24.0548606 27,23.6494607 27,23.1493746 C27,18.6485993 30.6485993,15 35.1493746,15 C38.6768786,15 41.5397974,16.9244432 42.7182788,19.9475654 Z"
              ></path>
            </g>
          </g></svg>
        >Appelez-nous
      </button>
    </div>
  </div>
  <div v-if="isLessThanLargeDesktop" v-html="$sanitize(sideBarContent)" class="covid-search-side" />
  <form class="covid-search-form">
    <div class="covid-search-form-inner">
      <div class="covid-search-form-toptext vacci-toptext" v-if="isLargeDesktop">
        <h1>
          {{ title }}
          <template v-if="secondTitle">
            <br/>
            <span> {{ secondTitle }} </span>
          </template>
        </h1>
        <p>
          {{ text }}
        </p>
        <div v-if="displayRogerVoice"  class="rogervoice-button-container white">
          <button
            type="button"
            class="roger-webapp-button"
            @click="$emit('onRogerVoiceClick')"
          >
            <svg
              role="img"
              aria-label="personnes sourdes et malentendantes"
              width="20px"
              height="20px"
              viewBox="0 0 28 28"
              version="1.1"
            >
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g
                  transform="translate(-25.000000, -15.000000)"
                  fill="#11485B"
                  fill-rule="nonzero"
                >
                  <!-- eslint-disable-next-line max-len -->
                  <path d="M25.9906539,38.7287954 C26.1914126,38.7099473 26.3871587,38.6242568 26.5418066,38.4715019 L47.948796,17.0117337 C48.2263318,16.9667216 48.5207924,17.0512139 48.7347893,17.2652107 C49.0884036,17.618825 49.0884036,18.1921471 48.7347893,18.5457614 L43.2622095,24.0183412 C43.1353361,25.5608973 42.6764302,27.3276574 41.8599943,29.7618398 C41.7344207,30.1362342 41.6049456,30.5143346 41.4255642,31.0326031 C40.2196811,34.5166369 39.7763645,35.9625642 39.6757128,37.1686008 C39.9052608,37.3328538 40.0548606,37.6016995 40.0548606,37.9054861 C40.0548606,40.4059168 38.027861,42.4329164 35.5274303,42.4329164 C33.0269996,42.4329164 31,40.4059168 31,37.9054861 C31,37.4053999 31.4053999,37 31.9054861,37 C32.4055722,37 32.8109721,37.4053999 32.8109721,37.9054861 C32.8109721,39.4057445 34.0271719,40.6219442 35.5274303,40.6219442 C36.8377096,40.6219442 37.9313164,39.6942593 38.1872745,38.4598658 C37.97643,38.2940797 37.8410162,38.0366829 37.8410162,37.7476585 C37.8410162,36.0819695 38.2224275,34.7502995 39.7142012,30.4402714 C39.891849,29.9270119 40.0196526,29.5537925 40.1430252,29.1859605 C40.5179886,28.0680167 40.8115756,27.1044858 41.0274668,26.2530839 L33.9285436,33.352007 C34.0842016,33.626085 34.3787386,33.8109721 34.7164582,33.8109721 C35.2165443,33.8109721 35.6219442,33.4055722 35.6219442,32.9054861 C35.6219442,32.4053999 36.0273442,32 36.5274303,32 C37.0275165,32 37.4329164,32.4053999 37.4329164,32.9054861 C37.4329164,34.4057445 36.2167166,35.6219442 34.7164582,35.6219442 C33.8794119,35.6219442 33.1307906,35.243352 32.6324887,34.648062 L26.5457614,40.7347893 C26.1921471,41.0884036 25.618825,41.0884036 25.2652107,40.7347893 C24.9115964,40.381175 24.9115964,39.8078529 25.2652107,39.4542386 L25.9906539,38.7287954 Z M33.5703861,28.983482 L31.866142,30.666865 C31.8040311,29.2067804 31.6692266,28.0389206 31.4677527,26.9462033 C31.4566706,26.8860985 31.1125344,25.2166941 31.0559445,24.7692767 C31.018857,24.4760512 31,24.1960296 31,23.9085024 C31,21.6083506 32.7726205,20 35.0746873,20 C37.1702351,20 38.9113377,21.5219137 39.1269221,23.4949615 L37.8721266,24.7343975 C37.557445,24.5925283 37.3384024,24.2760954 37.3384024,23.9085024 C37.3384024,22.7613 36.335484,21.8109721 35.0746873,21.8109721 C33.735621,21.8109721 32.8109721,22.6499331 32.8109721,23.9085024 C32.8109721,24.1172669 32.8247438,24.3217722 32.8526027,24.5420334 C32.8988089,24.9073547 33.2257747,26.4934655 33.2487055,26.6178332 C33.3851774,27.3580039 33.4928929,28.1282694 33.5703861,28.983482 Z M42.7182788,19.9475654 L41.2748789,21.3732971 C40.5743965,18.588473 38.2100984,16.8109721 35.1493746,16.8109721 C31.6487716,16.8109721 28.8109721,19.6487716 28.8109721,23.1493746 C28.8109721,23.6494607 28.4055722,24.0548606 27.9054861,24.0548606 C27.4053999,24.0548606 27,23.6494607 27,23.1493746 C27,18.6485993 30.6485993,15 35.1493746,15 C38.6768786,15 41.5397974,16.9244432 42.7182788,19.9475654 Z"
                  ></path>
                </g>
              </g></svg>
            >Appelez-nous
          </button>
        </div>
      </div>
      <fieldset>
        <legend class="sr-only">Selectionnez le département et la ville</legend>
        <div class="covid-search-form-fields">
          <div class="select">
            <select v-model="currentUrl"
              aria-label="Sélectionnez un département (rechargement de la fenêtre)"
              title="Sélectionnez un département (rechargement de la fenêtre)"
              @change="$emit('onRegionChange', currentUrl)"
            >
              <option value="0">- Sélectionnez votre département -</option>
              <option
                v-for="region in regions"
                :key="region.getValue()"
                :value="region.getValue()"
                :selected="currentUrl == region.getValue()"
              >
                {{ region.getLabel() }}
              </option>
            </select>
          </div>
        </div>
        <div v-if="cities.length" class="covid-search-form-fields">
          <div class="select">
            <select
              v-model="citySelected"
              aria-label="Sélectionnez une ville"
              title="Sélectionnez une ville"
              @change="$emit('onCityChange', citySelected)"
            >
              <option value="0">- Sélectionnez une ville -</option>
              <option
                v-for="city in cities"
                :key="city.getValue()"
                :value="city.getValue()"
              >
                {{ city.getLabel() }}
              </option>
            </select>
          </div>
        </div>
      </fieldset>
      <div v-if="places.length" class="covid-search-filters select48">
        <h2>Filtrer :</h2>
        <div class="select w-fit-content">
          <select
            id="type-lieu-select"
            aria-label="Sélectionner un Type de lieu"
            title="Sélectionner un Type de lieu"
            @change="
              $emit('onVaccinationCenterChange', vaccinationCenterType)
            "
            v-model="vaccinationCenterType"
          >
            <option value="0">Type de lieu</option>
            <option
              v-for="place in places"
              :key="place.getValue()"
              :value="place.getValue()"
            >
              {{ place.getLabel() }}
            </option>
          </select>
        </div>
        <fieldset v-if="vaccinationFilters?.length" class="form-group center-types">
          <legend class="sr-only">Type de centre</legend>
          <div
              v-for="vaccinationFilter in vaccinationFilters"
              :key="vaccinationFilter.value"
              class="checkbox-item"
            >
              <input
                type="checkbox"
                name="filter-creneau-rdv"
                :id="`filter-creneau--${vaccinationFilter.value}`"
                :value="vaccinationFilter.value"
                @change="$emit('onFilterChange',{checked: $event.target.checked,
                value: vaccinationFilter.value})"
              /><label
                :for="`filter-creneau--${vaccinationFilter.value}`"
                >{{ vaccinationFilter.label }}</label
              >
          </div>
        </fieldset>
      </div>
    </div>
  </form>
</template>
<script>
import { inject } from 'vue';
import { ContentService } from '@/services';

export default {
  emits: ['onRogerVoiceClick', 'onRegionChange', 'onCityChange', 'onVaccinationCenterChange', 'onFilterChange'],
  props: {
    regions: {
      type: Array,
      default: () => [],
    },
    cities: {
      type: Array,
      default: () => [],
    },
    places: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    secondTitle: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    displayRogerVoice: {
      type: Boolean,
      default: true,
    },
    vaccinationFilters: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const isLessThanLargeDesktop = inject('isLessThanLargeDesktop');
    const isLargeDesktop = inject('isLargeDesktop');
    const content = ContentService.getSearchCentersPageContents();
    const sideBarContent = content?.field_right_column_text
      && content?.field_right_column_text[0]?.value;
    const currentUrl = window.location.pathname === '/cf/centres-vaccination-covid.html' ? 0 : window.location.pathname;
    return {
      regionSelected: 0,
      citySelected: 0,
      vaccinationCenterType: 0,
      sideBarContent,
      isLessThanLargeDesktop,
      isLargeDesktop,
      currentUrl,
    };
  },
};
</script>
